export const infoTypes = {
  global: 'global',
  country: 'country',
}

export const viewInfoTypes = {
  map: 'map',
  list: 'list',
}

export const heatMapOptions = {
  totalOrdersCount: 'total_orders_count',
  totalOrderValue: 'total_order_value',
  averageOrderValue: 'average_order_value',
  incidentsInCustoms: 'incidents_in_customs',
}
